import { Component, ViewChild } from '@angular/core';
import { PlayerListService } from './player-list.service';
import { FormControl, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';

import { TablePlayerListComponent } from '../table-player-list/table-player-list.component';

@Component({
  selector: 'app-player-list',
  templateUrl: './player-list.component.html',
  styleUrls: ['./player-list.component.scss'],
})
export class PlayerListComponent {

  listaJogadores = new FormGroup({
    tipoBusca: new FormControl<string>(''),
    valorBusca: new FormControl<string>(''),
  });


  public isFilterColapsed = false;
  public isSubmitted = false;
  public isLoaded: boolean = false;
  public transactions: any[] = [];
  public userId: string = '';
  public document: string = '';
  public tipoBuscaList = [
    { name: 'ID Usuário', value: 'userId' },
    { name: 'Documento', value: 'document' },
    { name: 'Operador', value: 'accountId' },
    { name: 'Produto Lotérico', value: 'productId' },
  ];

  @ViewChild(TablePlayerListComponent) table!: TablePlayerListComponent;

  constructor(
    private playerListService: PlayerListService,
    private authService: AuthService,
    private toastr: ToastrService
  ) {
    this.listaJogadores.controls.tipoBusca.setValue('userId');
  }

  onTransactionsLoaded(lista: any[]): void {
    this.transactions = lista ?? [];
    this.isLoaded = true;
  }

  buscar() {
    this.isLoaded = false;

    this.table.page = 1;

    this.table.userId = '';
    this.table.document = '';
    this.table.accountId = '';
    this.table.productId = '';

    const searchType = (this.listaJogadores.controls.tipoBusca.value || 'userId').trim();
    let value = (this.listaJogadores.controls.valorBusca.value || '').trim();

    switch (searchType) {
      case 'document':
        value = this.onlyDigits(value);
        this.listaJogadores.controls.valorBusca.setValue(value, { emitEvent: false });
        this.table.document = value;
        break;

      case 'accountId':
        this.table.accountId = value;
        break;

      case 'productId':
        this.table.productId = value;
        break;

      case 'userId':
      default:
        this.table.userId = value;
        break;
    }

    this.table.getPlayers();
    this.isSubmitted = false;
  }

  private onlyDigits(v: string): string {
    return (v ?? '').toString().replace(/\D/g, '');
  }

  async paste(): Promise<void> {
    try {
      const text = await navigator.clipboard.readText();

      this.listaJogadores.controls.valorBusca.setValue(text.trim());

    } catch (err) {
      console.error('Erro ao colar o código:', err);
    }
  }

  filterColapse() {
    this.isFilterColapsed = !this.isFilterColapsed;
  }

}
